/* WhyGolf calculators — helpers shared by the tool pages styled with
   assets/wg-calc.css. Each tool keeps its math in its own pure engine file
   (tested in scripts/tests/) and its DOM wiring in its own section script;
   this file only holds what every one of them repeats.
   Browser: window.WGCalc. */
(function () {
  'use strict';

  // Events go through window.wgTrack (snippets/wg-tracking.liquid), which
  // prefixes the action with "wg_" and adds the section and page path.
  function track(action, params) {
    if (typeof window.wgTrack === 'function') window.wgTrack(action, params || {});
  }

  // "12.4", "12,4", " 12 " → number. NaN for anything else, including
  // negatives unless allowed. Empty is NaN: an empty field is incomplete.
  function num(value, options) {
    var o = options || {};
    var s = String(value === null || value === undefined ? '' : value).trim().replace(',', '.');
    if (s === '') return NaN;
    var pattern = o.negative ? /^-?\d+(\.\d+)?$/ : /^\d+(\.\d+)?$/;
    if (!pattern.test(s)) return NaN;
    var n = parseFloat(s);
    if (o.integer && n % 1 !== 0) return NaN;
    return n;
  }

  // A Handicap Index or course handicap as golfers write it: "12.4" is 12.4
  // and "+1.2" is a plus handicap, held as −1.2.
  function handicap(value) {
    var s = String(value === null || value === undefined ? '' : value).trim().replace(',', '.');
    if (!/^\+?\d{1,2}(\.\d)?$/.test(s)) return NaN;
    var n = parseFloat(s.replace('+', ''));
    return s.charAt(0) === '+' ? -n || 0 : n;
  }
  function fmtHandicap(n, places) {
    var p = places === undefined ? 0 : places;
    var f = Math.pow(10, p);
    var r = Math.round(n * f) / f || 0;
    var text = Math.abs(r).toFixed(p);
    return r < 0 ? '+' + text : text;
  }

  function money(n) {
    var r = Math.round(n * 100) / 100 || 0;
    var text = Math.abs(r) % 1 === 0 ? String(Math.abs(r)) : Math.abs(r).toFixed(2);
    return (r < 0 ? '−' : '') + '$' + text;
  }

  function checkedValue(list) {
    for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i].value;
    return null;
  }

  // Strips characters a field cannot hold as they are typed.
  function restrict(input, pattern) {
    input.addEventListener('input', function () {
      var next = input.value.replace(pattern, '');
      if (next !== input.value) input.value = next;
    });
  }

  function setHint(node, message, isError) {
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('wgc__hint--warn', !!isError);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function renderQr(root) {
    var box = root.querySelector('[data-wgc-qr]');
    if (!box || !box.dataset.qrUrl) return;
    var draw = function () {
      if (typeof window.qrcode !== 'function') return;
      try {
        var qr = window.qrcode(0, 'M');
        qr.addData(box.dataset.qrUrl);
        qr.make();
        box.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
      } catch (e) { /* no QR is fine; the button and badges remain */ }
    };
    if (document.readyState === 'complete') draw();
    else window.addEventListener('load', draw);
  }

  // Runs init(root) once for every element matching the selector, now and
  // whenever the theme editor reloads the section.
  function boot(selector, init) {
    function start(root) {
      if (!root || root.dataset.wgcReady) return;
      root.dataset.wgcReady = '1';
      init(root);
      renderQr(root);
    }
    function all() {
      document.querySelectorAll(selector).forEach(start);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
    else all();
    document.addEventListener('shopify:section:load', function (e) {
      start(e.target.querySelector(selector));
    });
  }

  window.WGCalc = {
    track: track,
    num: num,
    handicap: handicap,
    fmtHandicap: fmtHandicap,
    money: money,
    checkedValue: checkedValue,
    restrict: restrict,
    setHint: setHint,
    el: el,
    renderQr: renderQr,
    boot: boot
  };
})();
